// Mirrors spring.servlet.multipart.max-file-size (1GB) in both xmp-ingest's and
// add-cover-service's application.yml — kept in sync manually. The servers
// enforce it regardless (413 / SourcePdfFetcher); this client-side check only
// exists so an oversized file fails immediately instead of after a full upload.
// It applies to direct uploads only: a cover stage chained from xmp sends just
// a sourceUrl, so no file bytes leave the browser there.
export const MAX_SOURCE_PDF_BYTES = 1024 * 1024 * 1024;

const formatMb = (bytes) => `${Math.round(bytes / (1024 * 1024))}MB`;

export function oversizeMessage(file) {
  return `File is ${formatMb(file.size)}, exceeds the ${formatMb(MAX_SOURCE_PDF_BYTES)} upload limit - not uploaded`;
}
